import { defineMessages } from 'react-intl'

export const locale = defineMessages({
  importantInfo: {
    id: 'aip-modal.important-info',
    defaultMessage: 'Important information',
  },
  hostOptedIn: {
    id: 'aip-modal.host-opted-in',
    defaultMessage: 'The event organizer has opted in to {aipText} for this event.',
  },
  whatAipMeans: {
    id: 'aip-modal.what-aip-means',
    defaultMessage: 'This means you\'ll see the {totalText} including the ticket price plus fees, ' +
                    'before applicable taxes.',
  },
  totalUpFront: {
    id: 'aip-modal.total-cost-up-front',
    defaultMessage: 'Total Cost up front',
  },
  aip: {
    id: 'aip-modal.all-in-pricing',
    defaultMessage: 'All-In Pricing',
  },
  iAgree: {
    id: 'aip-modal.i-agree',
    defaultMessage: 'I agree',
  },
})
